import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Imported BEFORE index.css: this brings in the CoOrdio design tokens and the @coordio/ui
// component styles. MUST be a .css file (not .scss) so @tailwindcss/vite resolves @apply.
// IBM Plex Sans (the design-token font) loads from Google Fonts in index.html.
import './coordio-ui.css';
import './index.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import App from './App.tsx';
import { ThemeProvider } from './theme/ThemeProvider';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
